import { ReactNode } from 'react';
import { Divider, Flex, Text } from '@chakra-ui/react';

interface FormLayoutProps {
  header: ReactNode;
  secondaryHeader?: ReactNode;
  children?: ReactNode;
}

export const FormLayout = (props: FormLayoutProps) => {
  const { header, secondaryHeader, children } = props;

  return (
    <Flex direction='column' px={4} pb={4} mt='4'>
      <Flex direction='column'>
        <Text
          sx={{ fontSize: 'md', color: 'gray.700', letterSpacing: 0.3 }}
          as='span'
        >
          {header}
        </Text>
        {secondaryHeader && (
          <Text fontSize='sm' color='gray.700' fontWeight='hairline'>
            {secondaryHeader}
          </Text>
        )}
      </Flex>
      <Divider color='gray.300' my={2} />
      <Flex px={10} my={4}>
        {children}
      </Flex>
    </Flex>
  );
};
